import { Box, Typography } from '@mui/material';

interface AuthDividerProps {
  label?: string;
}

/** Horizontal rule with centred text label — "or" between form sections. */
export function AuthDivider({ label = 'or' }: AuthDividerProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <Box
        aria-hidden
        sx={{ flex: 1, height: '1px', bgcolor: 'divider' }}
      />
      <Typography
        component="span"
        sx={{
          fontSize: '0.71875rem', // 11.5px — caption size per design tokens
          textTransform: 'uppercase',
          letterSpacing: '0.14em',
          color: 'text.secondary',
        }}
      >
        {label}
      </Typography>
      <Box
        aria-hidden
        sx={{ flex: 1, height: '1px', bgcolor: 'divider' }}
      />
    </Box>
  );
}
